<template>
  <v-dialog
    width="600px"
    title="View Upload Content"
    :visible.sync="dialogVisible"
    @close="onClose"
    @closed="onClosed"
    split-line
  >
    <el-form label-width="190px">
      <template v-if="data">
        <el-form-item label="Content Category">
          <span>{{ data.CategoryName }}</span>
        </el-form-item>
        <el-form-item label="Short Title">
          <span>{{ data.ShortTitle }}</span>
        </el-form-item>
        <el-form-item label="Search Term">
          <span>{{ data.SearchTerm }}</span>
        </el-form-item>
        <el-form-item label="Allow Full Article Request">
          {{ data.FullPaperRequest === 1 ? "Yes" : "No" }}
        </el-form-item>
        <el-form-item label="Any Comments">
          <div ref="commentWrapper" class="any-comments-wrapper">
            {{ data.AnyComments }}
          </div>
        </el-form-item>
      </template>
    </el-form>
  </v-dialog>
</template>
<script>
export default {
  name: "view-team-content-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
  },
  data() {
    return {
      dialogVisible: this.visible,
    };
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onClose() {
      const commentWrapper = this.$refs.commentWrapper;
      if (commentWrapper) {
        commentWrapper.scrollTop = 0;
      }
    },
    onClosed() {
      this.$emit("update:data", null);
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-scrollbar.dialog {
    max-height: 100%;
    width: 600px;
    min-width: 600px;
    min-height: 10vw;
    .el-scrollbar__wrap {
      margin-bottom: 0 !important;
    }
  }
  .el-dialog__header {
    padding: 20px;
  }
  .el-form-item__label {
    color: #555;
    font-weight: bold;
  }
  .el-dialog__footer {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0px;
    display: flex;
    max-height: 70vh;
  }
}
.el-form {
  position: relative;
  padding: 30px 40px 0 15px;
  .el-form-item.content-container {
    margin-bottom: 0px;
  }
}
.link-wrap {
  max-width: 95%;
}
.any-comments-wrapper {
  padding-right: 30px;
  word-break: break-word;
  max-height: 200px;
  overflow: scroll;
  padding-right: 10px;
}
</style>
